// extracted by mini-css-extract-plugin
export default {"wrapper":"FilterWidget_wrapper__C7cTB","buttons":"FilterWidget_buttons__glmy1","button":"FilterWidget_button__zId3B","editModeButtons":"FilterWidget_editModeButtons__AgHc0"};